const _excluded = ["children", "style", "timeout"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import { jsx as ___EmotionJSX } from "@emotion/react";
function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}
const styles = {
  default: {
    opacity: 0,
    transform: getScale(0.75),
    transition: 'opacity 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: `${getScale(1)} translateZ(0)`
  },
  exiting: {
    opacity: 0,
    transform: getScale(0.75)
  },
  exited: {
    opacity: 0,
    transform: getScale(0.75)
  }
};
class Grow extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleEnter", node => {
      if (this.props.onEnter) this.props.onEnter(node);
    });
    _defineProperty(this, "handleExit", node => {
      if (this.props.onExit) this.props.onExit(node);
    });
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  render() {
    const _this$props = this.props,
      {
        children,
        style: styleProp,
        timeout
      } = _this$props,
      other = _objectWithoutProperties(_this$props, _excluded);
    const style = _objectSpread(_objectSpread(_objectSpread({}, styleProp), styles.default), /*#__PURE__*/React.isValidElement(children) ? children.props.style : {});
    return ___EmotionJSX(Transition, _extends({
      appear: true,
      onEnter: this.handleEnter,
      onExit: this.handleExit,
      timeout: timeout === 'auto' ? null : timeout
    }, other), (state, childProps) => {
      return /*#__PURE__*/React.cloneElement(children, _objectSpread({
        style: _objectSpread(_objectSpread({}, style), styles[state])
      }, childProps));
    });
  }
}
Grow.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  in: PropTypes.bool,
  onEnter: PropTypes.func,
  onExit: PropTypes.func,
  style: PropTypes.object,
  theme: PropTypes.object,
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
};
Grow.defaultProps = {
  timeout: 250
};
export default Grow;